const StarIcon = () => {
  return (
    <svg
      fill="none"
      height="11"
      viewBox="0 0 12 11"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.1441 0.345361C5.29378 -0.115295 5.94548 -0.115294 6.09516 0.345361L7.07897 3.37323C7.14591 3.57924 7.33788 3.71872 7.5545 3.71872H10.7382C11.2225 3.71872 11.4239 4.33852 11.0321 4.62323L8.45642 6.49455C8.28118 6.62187 8.20785 6.84755 8.27479 7.05357L9.2586 10.0814C9.40827 10.5421 8.88103 10.9251 8.48918 10.6404L5.91352 8.76912C5.73828 8.6418 5.50098 8.6418 5.32574 8.76912L2.75008 10.6404C2.35822 10.9251 1.83098 10.5421 1.98066 10.0814L2.96447 7.05357C3.03141 6.84755 2.95808 6.62187 2.78284 6.49455L0.207182 4.62322C-0.184675 4.33852 0.016713 3.71872 0.501075 3.71872H3.68476C3.90137 3.71872 4.09335 3.57924 4.16029 3.37323L5.1441 0.345361Z"
        fill="#002855"
      />
    </svg>
  )
}

export default StarIcon
